import React from "react";
import { Box } from "@mui/material";
import DynamicTableForJson from "../../data/DynamicTable/dynamicTableForJson";
import PerformanceForm from "./form";
import { userManagementUrl } from "../../config";
import { allReportTypes } from "../../data/Axios/queries";
const base_url = userManagementUrl.uri;

const TargetPerfomance = () => {
  const actions = {
    entity: localStorage.getItem("SelectedRight"),
    // edit: {
    //   key: "EDIT",
    //   button_name: "Edit",
    //   Show_Button: true,
    //   permission: "EditPermission",
    // },
    // add: {
    //   key: "ADD",
    //   button_name: "Add",
    //   Show_Button: true,
    //   permission: "CreatePermission",
    // },
    // activateDeactivate: {
    //   key: "ACTIVATEDEACTIVATE",
    //   button_name: "Deactivate",
    //   Show_Button: false,
    //   permission: "ActivatePermission",
    // },
    dataObject: {
      objectName: "perfomanceTargets",
      parameters: "",
    },
    showStatus: true,
    showMore: {
      search: false,
      min: 0,
      max: 0,
    },
  };

  return (
    <Box m="10px">
      <DynamicTableForJson
        title="Perfomance"
        subtitle="Target Perfomance"
        //columns={ReportTypesColumns}
        FormComponent={PerformanceForm}
        query={allReportTypes}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
};

export default TargetPerfomance;
